<template> 
  <div class="thumbnail_card">
    <div class="imgbox">
      <img :src="scenario.thumbnail">
    </div>
    <h3 class="thumbnail_title" v-if='scenario.showCheck===true'> {{scenario.name}}</h3>
    <p class="thumbnail_desc m-0 pt-2 oneline_text">{{(scenario.description.length<100)?scenario.description:scenario.description | truncate(100)}}</p>
    <ul class="thumbnail_card_icon">
      <li><span class="card_counter">{{scenario.level}}</span></li>
      <li v-if="scenario.type=='click'"><img src="https://app.humanfirewall.io/static/img/click.svg" width="17px"></li>
      <li title="Attachment" v-if="scenario.type=='attachment'" ><i class="fa fa-paperclip"></i></li>
      <li title="Data Entry" v-if="scenario.type=='data-entry'" ><i class="fas fa-keyboard envelope_size"></i></li>
      <li title="Announcement" v-if="scenario.type=='announcement'" ><i class="fa fa-bullhorn"></i></li>
      <li v-if="!scenario.channel_type || scenario.channel_type==0" :title="title"><i class="far fa-envelope envelope_size"></i></li>
      <li v-if="scenario.channel_type==1" title="SMS Campaign"><i class="fa fa-commenting"></i></li>             
    </ul>
    <div class="card_footer_btn">
      <button class="btn hf-btn-info card_btn_w btn_h" title="Use this scenario" @click='selectScenario(scenario.id)'>Use This</button>
      <a class="btn btn-default btn-sm card_btn_w btn_h ml-2" target="_blank" :href="'/previewScenario/'+scenario.id">Preview</a>                          
    </div>
  </div>
</template>
<script>
  export default {
    data() {
        return {
            bulk_campaign_id: this.$route.params.id,
            baseUrl: baseUrl,
            preview_scenario: '',
            filter: {
                showCheck: false
            }
        }
    },
    props: ['scenario', 'isEdit', 'campaignIndex', 'isChangeScenario', 'campaign_id', 'retest', 'campaigns'],
    beforeMount() {
        this.showCheckMessage();
        // For change in scenario
        this.$on('changesinScenario', function(value) {
            this.showCheckMessage();
        });
    },
    watch: {
        campaigns: function(val) {
            this.showCheckMessage();
        },
        scenario: function(val) {
            this.showCheckMessage();
        },
    },
    ready() {
    },
    methods: {
        showCheckMessage() {
            this.scenario.showCheck = false;
            _.map(this.campaigns, (maincamp) => {
                if (maincamp.scenario_id == this.scenario.id) {
                    this.scenario.showCheck = true;
                } else {
                    if (maincamp.childCampaign.send_after && maincamp.childCampaign.send_after != '' && maincamp.childCampaign.scenario_id == this.scenario.id) {
                        this.scenario.showCheck = true;
                    } else if (maincamp.childCampaign.send_after && maincamp.childCampaign.send_after != '' && maincamp.childCampaign.childCampaign.send_after && maincamp.childCampaign.childCampaign.send_after != '' && maincamp.childCampaign.childCampaign.scenario_id == this.scenario.id) {
                        this.scenario.showCheck = true;
                    }
                }
            });
        },
        cloneCampaign(id) {
            //past campaign list
            // services.cloneCampaignById(id).then((response) => {
            //     // this.draftCampaign = response.data;
            //     this.$router.push({ path: this.routePath + '/description/'+ response.id })
            // })

        },
        selectScenario(id) {
            let data =
                {
                    scenario_id: id,
                    bulk_campaign_id: this.bulk_campaign_id,
                    send_at: this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                }

            if (this.isChangeScenario && this.isEdit) {
                data.id = this.campaign_id
            }

            let url = '/bulk/campaign/schedule';
            if (this.retest) {
                data.id = this.campaign_id
                url = '/bulk/campaign/edit/schedule';
            }
            this.$http.post(url, data).then((response) => {
                // console.log(response,"ewf");
                //this.$router.push({ path: '/bulk/campains/schedule/' + this.bulk_campaign_id })
                $('#myModal').modal('hide');
                $('#myScenarioModal').modal('hide');
                // if(this.isEdit)
                // {
                // this.$parent.campaigns.$set(this.campaignIndex, response.data.data);
                // }
                // else
                // {    
                this.$parent.getCampaignById();
                this.$parent.$emit('showUpdateSuccessFullMesssage');
                // }

            });
        },
        showPreview(id) {

            this.$http.get('/library/scenarios/' + id).then((response) => {
                this.preview_scenario = response.data.scenario;
                if (this.preview_scenario.email_template.data) {
                    this.preview_scenario.email_template.data = JSON.parse(this.preview_scenario.email_template.data);
                }
                if (this.preview_scenario.landing_page_template.data) {
                    this.preview_scenario.landing_page_template.data = JSON.parse(this.preview_scenario.landing_page_template.data);
                }
                $('#preview_model_' + id).modal('show');
            });
        }

    }
}
</script>
 


// WEBPACK FOOTER //
// scenarioCard.vue?7c261682